export class SoItemDetailsBySoIdDTO {
    plant: number;
    brand: string;
    specie: string;
    variety: string;
    productForm: string;
    freezingType: string;
    packingStyle: string;
    grade: string;
    valAdditionOne?: string;
    noOfPouches?: number;
    pouchWeight?: number;
    productName?:string;
  species: any;
  uom: string;
  packStyleId?:number;
  varientId?:number;
  itemBarcode?:string;
  barcode?:string;

    constructor(plant: number,brand:string,specie:string,variety: string,productForm: string,freezingType: string,  packingStyle: string,grade: string,valAdditionOne?:string,
      noOfPouches?: number,pouchWeight?: number, productName?:string,species?: any,uom?:string,packStyleId?:number,varientId?:number,itemBarcode?:string,barcode?:string){
      this.plant = plant;
      this.brand = brand;
      this.specie = specie;
      this.variety = variety;
      this.productForm = productForm;
      this.freezingType = freezingType;
      this.packingStyle = packingStyle;
      this.grade = grade;
      this.valAdditionOne = valAdditionOne;
      this.noOfPouches = noOfPouches;
      this.pouchWeight = pouchWeight;
      this.productName = productName;
      this.uom = uom;
      this.packStyleId = packStyleId;
      this.varientId = varientId;
      this.itemBarcode = itemBarcode;
      this.barcode = barcode;

    }
  }